import React, {useContext, useState} from 'react';
import {Avatar, Button, Card, Grid, InputAdornment, Stack} from '@mui/material';
import {TextField} from 'formik-mui';
import './SetPassword.scss';
import Typography from '@mui/material/Typography';
import {useLocation, useNavigate} from 'react-router-dom';
import {Field, Form, Formik} from 'formik';
import {SNACKBAR_OPEN} from '../../../reducers';
import * as Yup from 'yup';
import {DispatchContext} from '../../../store';
import LockResetIcon from '@mui/icons-material/LockReset';
import {passwordResetServices} from '../../../services/InvitationServices';
import IconButton from '@mui/material/IconButton';
import {Visibility, VisibilityOff} from '@mui/icons-material';

const messages = {
  required: 'Field is required',
  email: 'Enter a valid email address',
  number: 'Invalid phone number',
};

const confirmValidateSchema = Yup.object().shape({
  password: Yup.string()
    .required(messages.required)
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one symbol'),
  confirm_password: Yup.string()
    .required(messages.required)
    .oneOf([Yup.ref('password'), null], 'Password Mismatch'),
});

export default function SetPassword() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const dispatch = useContext(DispatchContext);
  const location = useLocation();
  const searchParams = location.search;
  const paramsArray = searchParams.split('?').pop().split('&');
  let resetToken = null;

  paramsArray.forEach(param => {
    const [key, value] = param.split('=');
    if (key === 'reset_password_token') {
      resetToken = value;
    }
  });


  const resetInitialValue = {
    token: resetToken, password: '', confirm_password: ''
  };

  const handleSubmit = (values, {setSubmitting}) => {
    setSubmitting(false);
    passwordResetServices('post', {...values}, dispatch).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Successfully changed your password'},
      });
      navigate('/agency-login');
    });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickConfirmPassword = () => {
    setConfirmPassword(!confirmPassword);
  };

  return (
    <div className='field-container'>
      <Formik initialValues={resetInitialValue}
              validationSchema={confirmValidateSchema}
              onSubmit={handleSubmit}>
        {({
            values,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            ...formik
          }) => (
          <Form>
            <Card sx={{pl: 4, pr: 4, pt: 2, pb: 2}}>
              <div style={{marginBottom: '8%'}} align={'center'}>
                <LockResetIcon sx={{fontSize: 50, color: '#616b88'}}/>
                <Typography className='font-18 text-600 th-color pl-2 mt-2 mb-2'>
                  Change Your Password
                </Typography>
                <Typography className='font-14 th-color pl-2 mt-2 mb-2'>
                  Enter a new password below to change your
                </Typography>
                <Typography className='font-14 th-color mb-2'>
                  password
                </Typography>
              </div>
              <div>
                <Stack sx={{mb: 2}}>
                  <Field component={TextField} className='field-size' label='New Password' variant={'outlined'}
                         color={'primary'} type={!showPassword ? 'password' : "text"} name="password" required
                         InputProps={{
                           endAdornment: (
                             <InputAdornment position="end">
                               <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowPassword}
                                 edge="end"
                               >
                                 {showPassword ? <Visibility sx={{fontSize: 20}}/> : <VisibilityOff sx={{fontSize: 20}}/>}
                               </IconButton>
                             </InputAdornment>
                           ),
                         }}/>
                </Stack>
                <Stack sx={{mb: 2}}>
                  <Field component={TextField} className='field-size' label={'Confirm Password'} variant={'outlined'}
                         color={'primary'} type={!confirmPassword ? 'password' : 'text'} name="confirm_password" required
                         InputProps={{
                           endAdornment: (
                             <InputAdornment position="end">
                               <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickConfirmPassword}
                                 edge="end"
                               >
                                 {confirmPassword ? <Visibility sx={{fontSize: 20}}/> : <VisibilityOff sx={{fontSize: 20}}/>}
                               </IconButton>
                             </InputAdornment>
                           ),
                         }}/>
                </Stack>
                <div className='mt-4'>
                  <Button sx={{color: '#fff'}} type="submit" className='field-size' variant={'contained'}>Change
                    password</Button>
                </div>
              </div>
              <Stack sx={{mt: 2}}>
                <Typography className='font-14 th-color pl-2 mt-2 mb-2' align={'center'}>Copyright ©
                  MUSEUMS OF BHUTAN {new Date().getFullYear()}
                </Typography>
              </Stack>
            </Card>
          </Form>)}
      </Formik>
    </div>
  );
}
